function Prizes() {
  return (
    <section className="prize-section">
      <div className="container">

        <div className="section-header">
          <h2>Rewards & <span>Recognition</span></h2>
          <p>
            Compete, win big, and get officially recognized
          </p>
        </div>

        <div className="prize-content">

          <div className="prize-highlight">
            <h3>₹1,00,000+</h3>
            <p>Total Prize Pool</p>
          </div>

          <div className="prize-points">
            <div className="prize-point">
              🏆 Win exciting cash prizes and awards
            </div>
            <div className="prize-point">
              📜 Get a <strong>9-Point Participation Certificate For GTU</strong>
            </div>
            <div className="prize-point">
              🎓 Official certification for all participants
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default Prizes;
